<template>
  <div class="container">
    <v-dialog v-model="selectAccountDialog" max-width="400">
      <v-card class="ma-4" max-width="350" v-bind:key="account.id" v-for="account in selectAccountDialogEntries">
        <v-card-title class="text-wrap">
          <p>{{ account.name }}</p>
        </v-card-title>
        <v-card-subtitle>{{ `ΑΦΜ: ${account.tax_registration_number || '-'}` }}</v-card-subtitle>
        <v-card-text>
          <v-container>
            <v-row><div>{{ account.city }} {{ account.zipcode }}</div></v-row>
            <v-row><div>{{ account.address }}</div></v-row>
            <v-row><div>{{ account.telephone }}</div></v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="updateAccount('supplier', account); closeSelectAccountDialog();">ΕΠΙΛΟΓΗ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>Φίλτρα αναζήτησης</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" sm="6">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="documentIssueDateStartFilter"
                    label="Ημερομηνία έκδοσης (Από)"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable>
                  </v-text-field>
                </template>
                <v-date-picker v-model="documentIssueDateStartFilter" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="documentIssueDateStopFilter"
                    label="Ημερομηνία έκδοσης (Έως)"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable>
                  </v-text-field>
                </template>
                <v-date-picker v-model="documentIssueDateStopFilter" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <v-select
                :items="documentTypes"
                v-model="documentTypeFilter"
                return-object
                item-text="description"
                label="Είδος παραστατικού"
                clearable>
              </v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="supplier.name"
                label="Δικαιούχος / Προμηθευτής"
                append-icon="mdi-account-search"
                @click:append="searchAccountByName('supplier')"
                @keydown="clearAccount('supplier')">
              </v-text-field>
            </v-col>
          </v-row>

                    <v-row class="my-3" cols="12" align="center" justify="center">
            <v-btn 
                color="success" 
                rounded
                elevation="2"
                class="mx-2 px-5 font-weight-bold white--text"
                @click="getData" 
                :loading="getDataButtonDisabled"
            >
                <v-icon left size="20">mdi-magnify</v-icon>
                <span>ΑΝΑΖΗΤΗΣΗ</span>
            </v-btn>

            <v-btn 
                color="orange darken-2" 
                dark
                rounded
                elevation="2"
                class="mx-2 px-5 font-weight-bold white--text"
                @click="clearFilters" 
            >
                <v-icon left size="20">mdi-broom</v-icon>
                <span>ΚΑΘΑΡΙΣΜΑ</span>
            </v-btn>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      loading-text="Φόρτωση τίτλων κτήσης..."
      no-data-text="Δεν υπάρχουν δεδομένα"
      :sort-by="['issue_date']"
      :sort-desc="true"
      :item-class="row_class_generator"
      class="elevation-1 my-2"
      disable-pagination
      disable-filtering
      hide-default-footer>

      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Τίτλοι Κτήσης</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div>Σύνολο πληρωτέο: {{ listItemsSum.toFixed(2) }} €</div>
          <v-spacer></v-spacer>
          <v-btn 
            color="primary" 
            rounded 
            elevation="2" 
            class="m-2 px-4 font-weight-bold white--text" 
            @click="newDocumentButtonClicked"
          >
            <v-icon left size="20">mdi-plus</v-icon>
            <span>ΝΕΟΣ ΤΙΤΛΟΣ</span>
          </v-btn>

          <!-- Dialog Delete -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Διαγραφή εγγραφής {{ editedItem.document }};</v-card-title>
              <v-card-text>Η ενέργεια αυτή δεν μπορεί να αναιρεθεί.</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" @click="deleteItemConfirm" :loading="deleteButtonDisabled">ΔΙΑΓΡΑΦΗ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Dialog Cancel -->
          <v-dialog v-model="dialogCancel" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Ακύρωση εγγραφής {{ editedItem.document }} στην ΑΑΔΕ;</v-card-title>
              <v-card-text>Θα διαβιβαστεί ακύρωση του παραστατικού στο myDATA.</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="closeCancel">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" @click="cancelItemConfirm" :loading="cancelButtonDisabled">ΑΚΥΡΩΣΗ myDATA</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:[`item.issue_date`]="{ item }">
        {{ formatDate(item.issue_date) }}
      </template>

      <template v-slot:[`item.mydata_status`]="{ item }">
        <v-chip v-if="item.is_cancelled" small color="red" text-color="white">
          ΑΚΥΡΩΜΕΝΟ
        </v-chip>
        <v-chip v-else-if="item.invoice_mark" small color="green" text-color="white">
          Mark: {{ item.invoice_mark }}
        </v-chip>
        <v-chip v-else small color="orange" text-color="white">
          ΕΚΚΡΕΜΕΙ
        </v-chip>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small color="primary" class="mr-2" v-bind="attrs" v-on="on" @click="printPdf(item)">
              mdi-file-pdf-box
            </v-icon>
          </template>
          <span>Εκτύπωση PDF</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small color="blue-grey" class="mr-2" v-bind="attrs" v-on="on" @click="printReceipt(item)">
              mdi-receipt
            </v-icon>
          </template>
          <span>Εκτύπωση Απόδειξης</span>
        </v-tooltip>

        <v-tooltip bottom v-if="!item.is_cancelled && !item.invoice_mark">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small color="info" class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </template>
          <span>Επεξεργασία</span>
        </v-tooltip>

        <v-tooltip bottom v-if="!item.is_cancelled && !item.invoice_mark">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small color="error" class="mr-2" v-bind="attrs" v-on="on" @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
          <span>Διαγραφή</span>
        </v-tooltip>

        <v-tooltip bottom v-if="!item.is_cancelled && item.invoice_mark">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small color="warning" class="mr-2" v-bind="attrs" v-on="on" @click="cancelItem(item)">
              mdi-cancel
            </v-icon>
          </template>
          <span>Ακύρωση myDATA</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
  name: "AcquisitionDocumentsPage",
  data: () => ({
      loading: true,
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    dialogDelete: false,
    dialogCancel: false,
    deleteButtonDisabled: false,
    cancelButtonDisabled: false,
    getDataButtonDisabled: false,

    menu1: null,
    menu2: null,
    documentIssueDateStartFilter: null,
    documentIssueDateStopFilter: null,
    documentTypeFilter: null,
    documentTypes: [],

    supplier: {},
    selectAccountDialog: false,
    selectAccountDialogEntries: [],

    items: [],
    headers: [
      { text: "Ημερομηνία", value: "issue_date", align: "start" },
      { text: "Παραστατικό", value: "document", align: "start" },
      { text: "Δικαιούχος", value: "supplier_name", align: "start" },
      { text: "ΑΦΜ", value: "tax_registration_number", align: "start" },
      { text: "Καθαρή αξία", value: "net_value", align: "end" },
      { text: "Παρακρ. Φόρος", value: "tax_withholding_amount", align: "end" },
      { text: "Ψηφ. Τέλος", value: "stamp_duty_amount", align: "end" },
      { text: "Πληρωτέο", value: "gross_value", align: "end" },
      { text: "myDATA", value: "mydata_status", align: "center", sortable: false },
      { text: "Ενέργειες", value: "actions", sortable: false, align: "center" },
    ],
  }),

  computed: {
    listItemsSum() {
      return this.items.reduce((acc, item) => {
        const val = parseFloat(String(item.gross_value).replace(/\./g, "").replace(",", ".")) || 0;
        return acc + val;
      }, 0);
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const today = new Date();
      const filterStart = new Date();
      filterStart.setDate(today.getDate() - 30);

      this.documentIssueDateStartFilter = this.$localDateString ? this.$localDateString(filterStart) : moment(filterStart).format("YYYY-MM-DD");
      this.getFilterValues();
      this.getData();
    },

    getFilterValues() {
      axios.get("/api/document-types/acquisition")
        .then((response) => {
          this.documentTypes = response.data;
        })
        .catch((err) => console.error(err));
    },

    getRequestParams() {
      return {
        issue_date_start: this.documentIssueDateStartFilter,
        issue_date_stop: this.documentIssueDateStopFilter,
        document_type_id: this.documentTypeFilter?.id ?? null,
        supplier_id: this.supplier?.id ?? null,
      };
    },

    getData() {
        this.loading = true;
      this.getDataButtonDisabled = true;
      axios.get("/api/documents/acquisition/grid", { params: this.getRequestParams() })
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => console.error(error))
        .finally(() => {
          this.getDataButtonDisabled = false;
          this.loading = false;
        });
    },

    clearFilters() {
      this.documentIssueDateStartFilter = null;
      this.documentIssueDateStopFilter = null;
      this.documentTypeFilter = null;
      this.supplier = {};
      this.getData();
    },

    newDocumentButtonClicked() {
      this.$router.push({ name: "newacquisitiondocument" });
    },

    formatDate(value) {
      return value ? moment(value).format("DD/MM/YYYY") : "-";
    },

    row_class_generator(item) {
      if (item.is_cancelled) return "grey lighten-3 text--disabled";
      return "";
    },

    printPdf(item) {
      window.open(`/acquisitiondocuments/pdf/${item.uuid}`, "_blank").focus();
    },

    printReceipt(item) {
      window.open(`/acquisitiondocuments/receipt/${item.uuid}`, "_blank").focus();
    },

    editItem(item) {
      this.$router.push({ name: "editacquisitiondocument", params: { id: item.id } });
    },

    deleteItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.deleteButtonDisabled = true;
      axios.delete(`/api/documents/acquisition/${this.editedItem.id}`)
        .then(() => {
          this.items.splice(this.editedIndex, 1);
          this.closeDelete();
        })
        .catch((error) => console.error(error))
        .finally(() => {
          this.deleteButtonDisabled = false;
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    cancelItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogCancel = true;
    },

    cancelItemConfirm() {
      this.cancelButtonDisabled = true;
      axios.get(`/api/documents/acquisition/${this.editedItem.id}/cancel`)
        .then(() => {
          this.items[this.editedIndex].is_cancelled = true;
          this.closeCancel();
        })
        .catch((error) => console.error(error))
        .finally(() => {
          this.cancelButtonDisabled = false;
        });
    },

    closeCancel() {
      this.dialogCancel = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    searchAccountByName(target) {
      if (!this[target].name || this[target].name.length < 2) return;
      axios.get(`/api/accounts?name=${encodeURIComponent(this[target].name)}`)
        .then((response) => {
          if (response.data.length === 1) {
            this.updateAccount(target, response.data[0]);
          } else if (response.data.length > 1) {
            this.selectAccountDialogEntries = response.data;
            this.selectAccountDialog = true;
          }
        })
        .catch((err) => console.error(err));
    },

    updateAccount(target, account) {
      this[target] = Object.assign({}, account);
    },

    clearAccount(target) {
      this[target] = {};
    },

    closeSelectAccountDialog() {
      this.selectAccountDialog = false;
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 100%;
}
</style>
